/**
 * Accepts a key term string and uses it to create a case-insensitive regex pattern that matches words containing
 * the specificied substring, which could appear as the key term string followed by optional suffixes,
 * including -s, -es, -ed, -d, and -ing to try to account for potential variations.
 * @param {string} keyTerm
 * @returns {RegExp}
 */
const keyTermRegex = (keyTerm) => {
  if (!keyTerm) return;

  const term = `\\b(${keyTerm}(?:s|es|ed|d|ing)?)\\b(?!\\w)(.*)`;
  const modifiers = "gis";
  const regexPattern = new RegExp(term, modifiers);

  return regexPattern;
};

export default keyTermRegex;
